

/** Based on Bootstrap Modal availble on https://getbootstrap.com/docs/4.0/components/modal/
 *	<div class="modal" tabindex="-1" role="dialog">
 *		<div class="modal-dialog" role="document">
 *			<div class="modal-content">
 *				<div class="modal-header">
 *					<h5 class="modal-title">Modal title</h5>
 *					<button type="button" class="close" data-dismiss="modal" aria-label="Close">
 *						<span aria-hidden="true">&times;</span>
 *					</button>
 *					</div>
 *				<div class="modal-body">
 *					<p>Modal body text goes here.</p>
 *				</div>
 *				<div class="modal-footer">
 *					<button type="button" class="btn btn-primary">Save changes</button>
 *					<button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
 *				</div>
 *			</div>
 *		</div>
 *	</div>
 */
class Modal {

	defaultOptions(){
		return {
			//data
			'id': window.uniqid(),
			'title': '',
			'subtitle': null,
			'content': '',
			'container': window.App.getTopDocument(),

			//display configuration
			'titleMarkup': 'h5',
			'subtTitleMarkup': 'h6',
			'modalDialogDom': 'div',
			'modalClass': '',
			'modalDialogClass': 'modal-dialog',
			'modalContentClass': 'modal-content',
			'modalHeaderClass': 'modal-header',
			'modalTitleClass': 'modal-title',
			'modalSubTitleClass': 'modal-title',
			'modalBodyClass': 'modal-body',
			'modalFooterClass': 'modal-footer',

			//advanced display configuration
			'verticalCentered': true,
			'modalSize': '',
			'staticModal': false,

			//
			'showFooter': false,
			'showHeader': true,
			'onCloseDestroy': false,


			//callbacks
			'onClose':function(event,modal){},
			'onShown':function(event,modal){},
		};
	}

	constructor(options){
		this.settings = $.extend(this.defaultOptions(),options);

		// initialize attributes
		//this.$example = $('.class',this.$container);
		this.$modal = $('<div/>');

		if(this.settings.id === null){
			this.id = 'modalId' + window.uniqid();
		}else{
			this.id = this.settings.id;
		}

		// bind events methods
		//this.onEvent = this.onEvent.bind(this);
		this.onClose = this.onClose.bind(this);
		this.onShown = this.onShown.bind(this);
		// initalize object
		this.initialize();
	}

	initialize(){
		var self = this;
		this.$modal
		.attr('id',this.id)
		.addClass('modal fade')
		.addClass(this.settings.modalClass)
		.attr('tabindex','-1')
		.attr('role','dialog');
		this.getWrapper().append(this.$modal);


		this.$modal.on('force-close',function(event){
			self.hide();
		})

		this.$modalDialog = $('<' + this.settings.modalDialogDom + '/>')
		.addClass('modal-dialog')
		.addClass(this.settings.modalDialogClass)
		.attr('role','document')
		.appendTo(this.$modal);

		switch(this.settings.modalSize){
			case 'max':
			case 'full':
				this.$modalDialog.addClass('modal-full');
			break;

			case 'xl':
			case 'xxl':
				this.$modalDialog.addClass('modal-xl');
			break;

			case 'large':
			case 'lg':
				this.$modalDialog.addClass('modal-lg');
			break;

			case 'small':
			case 'sm':
				this.$modalDialog.addClass('modal-sm');
			break;

			default:
			//do nothing
			break;
		}

		if(this.settings.verticalCentered){
			this.$modalDialog.addClass('modal-dialog-centered');
		}

		this.$modalContent = $('<div/>')
		.addClass('modal-content')
		.addClass(this.settings.modalContentClass)
		.appendTo(this.$modalDialog);

		this.$modalHeader = $('<div/>')
		.addClass('modal-header')
		.addClass(this.settings.modalHeaderClass)
		.appendTo(this.$modalContent);

		if(!this.settings.showHeader){
			this.$modalHeader.hide();
		}

		this.$title = $('<'+this.settings.titleMarkup+'/>')
		.addClass('modal-title')
		.addClass(this.settings.modalTitleClass)
		.append(this.settings.title)
		.appendTo(this.$modalHeader);

		if(this.settings.subtitle){
			this.$subtitle = $('<'+this.settings.subtTitleMarkup+'/>')
			.addClass(this.settings.modalSubTitleClass)
			.append(this.settings.subtitle)
			.appendTo(this.$title);
		}


		this.$btnClose = $('<button/>')
		.attr('type','button')
		.addClass('btn btn-text text-secondary close')
		.attr('data-dismiss','modal')
		.attr('aria-label','Close')
		.append(
			$('<span/>')
			.attr('aria-hidden','true')
			.append('&times;')
		)
		.appendTo(this.$modalHeader)
		.on('click',function(event){
			self.hide();
		});


		this.$modalBody = $('<div/>')
		.addClass('modal-body')
		.addClass(this.settings.modalBodyClass)
		.append(this.settings.content)
		.appendTo(this.$modalContent);

		this.$modalFooter = $('<div/>')
		.addClass('modal-footer')
		.addClass(this.settings.modalFooterClass)
		.appendTo(this.$modalContent);

		if(!this.settings.showFooter){
			this.$modalFooter.hide();
		}

		this.$modal.on('hide.bs.modal',this.onClose);
		this.$modal.on('shown.bs.modal',this.onShown);
	}

	getModal(){
		if(!this.modal){
			let id = this.settings.id;
			let options = {
				'show': false,
				'focus': false,
				'keyboard': this.settings.staticModal ? false : true,
				'backdrop': this.settings.staticModal ? 'static' : true,
			};
			try{
				this.modal = new bootstrap.Modal(document.getElementById(id),options);
			}catch(e){
				console.error(e);
				window.notify("Une erreur est advenue lors de l'ouverture de cette fenêtre","danger");
			}
		}
		return this.modal;
	}

	onDOM(){
		return this;
	}

	getWrapper(){
		if(window.App && window.App.get('forcedModalWrapper')){
			return window.App.get('forcedModalWrapper');
		}
		if($('#outofscope',this.settings.container).length <= 0){
			$('body').append($('<div/>').attr('id','outofscope'));
		}
		return $('#outofscope',this.settings.container);
	}

	onShown(event){
		if(this.settings.onShown){
			this.settings.onShown(event,this);
		}
	}

	onClose(event){
		if(this.settings.onClose){
			this.settings.onClose(event,this);
		}
		if(this.settings.onCloseDestroy){
			this.dispose();
		}
	}

	show(){
		this.getModal().show();
		return this;
	}

	hide(){
		this.getModal().hide();
		return this;
	}

	toggle(){
		this.getModal().toggle();
		return this;
	}

	dispose(){
		var self = this;
		this.hide();
		setTimeout(
			function(){
				self.$modal.remove();
				let $modals = $('.modal:visible');
				if($modals.length <= 0){
					$('.modal-backdrop').remove();
				}
			},
			1000
		);
		return this;
	}

	destroy() {
		this.$modal.remove();
		return this;
	}

	triggerClose(){
		this.$modal.trigger('hidden.bs.modal');
	}

	setTitle($title){
		this.$title.html($title);
		return this;
	}

	setContent($content){
		this.$modalContent.html($content);
		return this;

	}

	setBodyContent($content){
		this.$modalBody.html($content);
		return this;
	}

	setHeaderContent($content){
		this.$modalHeader.html($content);
		return this;
	}

	setFooterContent($content){
		this.$modalFooter.html($content);
		return this;
	}

	getHeight(){
		return this.$modal.height();
	}

	getWidth(){
		return this.$modal.width();
	}

}

module.exports = Modal;